import {z} from 'zod'
export const imageMock = new URL('./mockImage.png', import.meta.url).href

export const defaultValues = {
  tierId: '',
  activities: [
    {
      activityID: '',
      multiplier: 1.0,
    },
  ],
  content: {
    'es-MX': {
      tierName: '',
      displayDescription: '',
      imageTierIcon: '',
      bannerHeader: '',
      bannerDescription: '',
      bannerImage: '',
      descriptionDetail: '',
      termsAndConditions: '',
      detailsImage: '',
    },
    'en-US': {
      tierName: '',
      displayDescription: '',
      imageTierIcon: '',
      bannerHeader: '',
      bannerDescription: '',
      bannerImage: '',
      descriptionDetail: '',
      termsAndConditions: '',
      detailsImage: '',
    },
  },
}

const displayItemSchema = z.object({
  tierName: z.string().nonempty("Tier Name is required"),
  displayDescription: z.string().optional(),
  imageTierIcon: z.string().nonempty("Tier Icon is required"),
  bannerHeader: z.string().nonempty("Banner Header is required"),
  bannerDescription: z.string().optional(),
  bannerImage: z.string().nonempty("Banner Image is required"),
  descriptionDetail: z.string().nonempty(),
  termsAndConditions: z.string().optional(),
  detailsImage: z.string().nonempty(),
})

export const activityItemSchema = z.object({
  activityID: z.string().nonempty(),
  multiplier: z.number().positive(),
})

export const createTierSchema = z.object({
  tierId: z.string().nonempty(),
  activities: z.array(activityItemSchema).min(1),
  content: z.object({
    'en-US': displayItemSchema,
    'es-MX': displayItemSchema,
  }),
})

export const mockReview = {
  tierId: 'Platinum',
  activities: [
    {
      activityID: '1',
      multiplier: 1.5,
    },
    {
      activityID: '2',
      multiplier: 3.5,
    },
  ],
  content: {
    'es-MX': {
      tierName: 'Platinum',
      displayDescription: 'Gana recompensas con actividades.',
      imageTierIcon: imageMock,
      bannerHeader: '¡Bienvenido al Oro!',
      bannerDescription: 'Beneficios exclusivos para ti.',
      bannerImage: imageMock,
      descriptionDetail: 'Completa tareas y encuestas para ganar puntos.',
      termsAndConditions: 'Aplican términos y condiciones.',
      detailsImage: imageMock,
    },
    'en-US': {
      tierName: 'Platinum',
      displayDescription: 'Earn rewards with activities.',
      imageTierIcon: imageMock,
      bannerHeader: 'Welcome to Gold!',
      bannerDescription: 'Exclusive benefits for you.',
      bannerImage: imageMock,
      descriptionDetail: 'Complete tasks and surveys to earn points.',
      termsAndConditions: 'Terms and conditions apply.',
      detailsImage: imageMock,
    },
  },
}
